import { ISimplePosService } from "../interfaces/ISimplePosService"

const GetSimplePosByDeviceUseCase = async (service: ISimplePosService, localId: string, deviceId: string) => {
    const response = await service.GetSimplePosByDeviceId(localId, deviceId);
    return (response.items)
}
export default GetSimplePosByDeviceUseCase